// extracted by mini-css-extract-plugin
export default {"imageWebp":"ImageWebp_imageWebp__6rGnI","imageWebp_loader":"ImageWebp_imageWebp_loader__62zBG"};